import EndOfTherapyFeedback from '@sleepstation/components-end-of-therapy-feedback'
import { paddingTop } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  ${paddingTop([1.5, 2])}
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const FeedbackEndOfTherapyPage = ({ onComplete }) => (
  <Layout>
    <EndOfTherapyFeedback onComplete={onComplete} />
  </Layout>
)

FeedbackEndOfTherapyPage.propTypes = {
  onComplete: PropTypes.func.isRequired,
}

FeedbackEndOfTherapyPage.defaultProps = {}

export default FeedbackEndOfTherapyPage
